import { getToken } from 'common/services/token.service';

export const options = {
  interceptors: {
    // every time we make an http request, this will run 1st before the request is made
    // url, path and route are supplied to the interceptor
    // request options can be modified and must be returned
    request: async ({ options, url, path, route }) => {
      options.headers.Authorization = `Bearer ${getToken()}`;
      return options;
    }
  },
  cachePolicy: 'no-cache'
};
